import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AppTheme from './shared-theme/AppTheme';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './queryClient';
import './i18n';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppTheme>
        <App />
      </AppTheme>
    </QueryClientProvider>
  </React.StrictMode>
);
